import { useTranslation } from 'react-i18next';
import { usePTPConfigContext } from 'GlobalConfig.context';
import { lineItemsTestID } from 'components/MerchantTrackingWidget/constants';
import { CarrierInformationProvider } from 'components/MerchantTrackingWidget/context';
import { useCurrentShipment } from '../../hooks/useCurrentShipment';

import { TrackingDetails } from './components/TrackingDetails';
import { ShipmentDetails } from './components/ShipmentDetails';
import { ShipmentLayout } from '../ShipmentLayout';
import { Section } from '../Section';
import { LineItems } from '../LineItems';

interface ForwardShipmentProps {
  hasMultipleShipments: boolean;
}

export const ForwardShipment = ({
  hasMultipleShipments,
}: ForwardShipmentProps): JSX.Element => {
  const { t } = useTranslation();
  const {
    lineItem: { isEnabled: isEnabledLineItem, sectionTitle },
  } = usePTPConfigContext();
  const { shipment } = useCurrentShipment();

  const parcelDetails = <ShipmentDetails shipment={shipment} />;

  const trackingDetails = (
    <TrackingDetails
      shipment={shipment}
      hasMultipleShipments={hasMultipleShipments}
    />
  );

  const title = sectionTitle || t('LINE_ITEMS_PARCEL_CONTENT');
  const additionalContent = (
    <>
      {isEnabledLineItem && shipment.lineItems?.length > 0 && (
        <Section title={title} dataTestId={`${lineItemsTestID}-section`}>
          <LineItems lineItems={shipment.lineItems} />
        </Section>
      )}
    </>
  );

  return (
    <CarrierInformationProvider shipment={shipment}>
      <ShipmentLayout
        parcelDetails={parcelDetails}
        trackingDetails={trackingDetails}
        additionalContent={additionalContent}
      />
    </CarrierInformationProvider>
  );
};
